import React, { useState } from "react"
import { Button, Divider, Dropdown, Radio, Space, Typography, theme } from "antd"
import { CloseOutlined, DownOutlined } from "@ant-design/icons"
import { useSelector } from "react-redux"
import { PatientStatus } from "./Types"

const { useToken } = theme

const PatientStatusFilterDropdown = props => {
  const { onPatientStatusSelection, onPatientStatusSelectionClear } = props
  const { token } = useToken()
  const { isDark } = useSelector(state => state.themeConfig)

  const [open, setOpen] = useState(false)
  const [values, setValues] = useState()
  const [selectedPatientStatus, setSelectedPatientStatus] = useState()

  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary
    // width: "140%"
  }

  const handleApply = () => {
    setOpen(false)
    setSelectedPatientStatus(values)
    onPatientStatusSelection(values)
  }

  const handleResetFilter = () => {
    setSelectedPatientStatus("")
    setValues("")
    onPatientStatusSelectionClear()
  }

  const onOpenChange = open => {
    if (!open) {
      setValues(selectedPatientStatus)
    }
    setOpen(open)
  }

  const onCaretakerOptionChange = e => {
    setValues(e.target.value)
  }
  return (
    <>
      <Dropdown
        open={open}
        onOpenChange={onOpenChange}
        destroyPopupOnHide
        menu={{ items: [] }}
        trigger={["click"]}
        className="flex-1 bg-[#fff]"
        dropdownRender={_ => (
          <div style={contentStyle}>
            <div className="pt-2 px-4 mr-8">
              <Radio.Group onChange={onCaretakerOptionChange} value={values}>
                <Space direction="vertical">
                  {Object.values(PatientStatus)?.map(val => (
                    <Radio key={val} value={val}>
                      {val}
                    </Radio>
                  ))}
                </Space>
              </Radio.Group>
            </div>
            <Divider className="my-3" />

            <div className="px-8 pb-4 flex justify-center">
              <Button type="primary" onClick={handleApply}>
                Done
              </Button>
            </div>
          </div>
        )}>
        <Button
          style={{
            // minWidth: 150,
            height: "inherit"
          }}>
          <div className="flex items-center justify-center gap-2">
            {(selectedPatientStatus?.length && (
              <>
                <Typography.Link>Patient Status : {selectedPatientStatus}</Typography.Link>
                <Typography.Link>
                  <DownOutlined />
                </Typography.Link>
              </>
            )) || (
              <>
                Patient Status
                <DownOutlined />
              </>
            )}
          </div>
        </Button>
      </Dropdown>
      <Space.Compact
        className={`border card ${isDark ? "dark" : "light"} `}
        onClick={handleResetFilter}
        style={{ borderWidth: 1 }}>
        <span className="secondary px-4 pt-2">
          <CloseOutlined />
        </span>
      </Space.Compact>
    </>
  )
}

export default PatientStatusFilterDropdown
